import { useCallback } from 'react';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';
import { Canvas } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Canvas';
import { useBranches } from '../../../../state/Branches/hooks/useBranches';
import { NodeTypeKeys } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/utils/NodeTypeKeys';
import { useRemoveBranches } from '../../../../state/Branches/actions/useRemoveBranches';
import { useCloseDrawer } from '../../../../state/Drawer/actions/useCloseDrawer';
import { useCampaignEditorContext } from '../../../../../../contexts/CampaignEditorContext';

export const useOnBranchRemove = () => {
  const { state, dispatch } = useWorkFlowCanvas();
  const { organiseBranches } = useBranches();
  const removeBranches = useRemoveBranches();
  const closeDrawer = useCloseDrawer();
  const { dispatch: campaignEditorDispatch } = useCampaignEditorContext();

  return useCallback(
    (controlNodeId: string) => {
      // Get all display web content nodes so we can remove all but the first one later
      const displayWebContentNodes = state.nodes.filter(s => s.type === NodeTypeKeys.displayWebContentNodeType);

      const { nodes, edges } = Canvas.createFromState(state)
        .removeBranch(controlNodeId)
        .convertToState();

      const controlNode = nodes.find(s => s.type === NodeTypeKeys.branchControlNodeType);
      if (controlNode) {
        organiseBranches(nodes.filter(s => controlNode.data.children.includes(s.id)).map(s => s.id));
      } else {
        const displayContentNode = nodes.find(s => s.type === NodeTypeKeys.displayWebContentNodeType);
        if (displayContentNode) {
          // We're removing all branches. So if we still have a web content node underneath, we'll
          // need to nullify the schedule since this should only apply to web content nodes under a branch
          campaignEditorDispatch({
            type: 'REMOVE_SEGMENT_DATETIMES',
            payload: {
              id: displayContentNode.id,
            },
          });
        }
        removeBranches();
        closeDrawer();

        // See if we have any display web content nodes that need to be removed from the state
        const displayWebContentNodesToRemove = displayWebContentNodes.filter(s => s.id !== displayContentNode.id);
        displayWebContentNodesToRemove.forEach(node => {
          // Remove em
          campaignEditorDispatch({
            type: 'REMOVE_DISPLAY_WEBSITE_CONTENT',
            payload: { id: node.id },
          });
        });
      }

      // Update the canvas
      dispatch({
        type: 'UPDATE',
        payload: { nodes, edges },
      });
    },
    [dispatch, campaignEditorDispatch, organiseBranches, removeBranches, closeDrawer, state],
  );
};
